module.exports = __webpack_public_path__ + "img/google-docs.b0f53ab2.svg";